module.exports = __webpack_public_path__ + "img/north.2f65b5cc.jpg";